export enum OncologyManagementLink {
    LabCaseAndPathology = '/pages/labCasePathology',
    LookupDefinition = '/pages/lookupDefinition',
    ProtocolDefinition = '/pages/protocolDefinition',
}
